module.exports = __webpack_public_path__ + "static/media/hero-bg.17fe9da2.png";